(() => {
  const copyNode = document.getElementById('EcWelcomeCopy');
  if (!copyNode) return;
  const copy = JSON.parse(copyNode.textContent);
  const setText = (node, value) => {
    if (node && node.dataset.ecCopy !== value) { node.textContent = value; node.dataset.ecCopy = value; }
  };
  const overlayStyle = document.createElement('style');
  overlayStyle.textContent = 'html.ecWelcomeOpen shopify-chat{visibility:hidden!important;pointer-events:none!important}';
  document.head.append(overlayStyle);
  let rootObserver;
  let observedRoot;
  const decorate = (root) => {
    const campaign = root.querySelector('.pc-campaign-198486');
    const code = Array.from(root.querySelectorAll('.code-wrapper')).find(node => node.textContent.trim() === 'HELLO_10');
    const modal = campaign?.closest('#pc-modal-backdrop') || code?.closest('#pc-modal-backdrop');
    document.documentElement.classList.toggle('ecWelcomeOpen', Boolean(modal));
    if (!modal) return;
    modal.dataset.ecWelcome = 'true';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', copy.title);
    if (!root.querySelector('#EcWelcomeStyles')) {
      const style = document.createElement('style');
      style.id = 'EcWelcomeStyles';
      style.textContent = `
        #pc-modal-backdrop[data-ec-welcome] .modal-card{width:min(490px,calc(100vw - 32px))!important;max-width:490px!important;max-height:calc(100dvh - 40px)!important;overflow-y:auto!important;background:#faf8f5!important;border-radius:0!important;box-shadow:0 20px 80px #0003!important}
        #pc-modal-backdrop[data-ec-welcome] .pop-content-blocks{background:#faf8f5!important;padding:45px 35px 30px!important;color:#242424!important;font-family:Arial,Helvetica,sans-serif!important;box-shadow:none!important}
        #pc-modal-backdrop[data-ec-welcome] .blocks-renderer,#pc-modal-backdrop[data-ec-welcome] .block-content{padding:0!important;color:#242424!important}
        #pc-modal-backdrop[data-ec-welcome] .text-block h1{font:400 39px/1.1 Arial,Helvetica,sans-serif!important;letter-spacing:-1.4px!important;color:#242424!important;margin:0 0 20px!important;text-align:left!important}
        #pc-modal-backdrop[data-ec-welcome] .text-block p{font:14px/1.8 Arial,Helvetica,sans-serif!important;color:#625a52!important;text-align:left!important;margin:0 0 23px!important}
        #pc-modal-backdrop[data-ec-welcome] .text-block p:empty{display:none!important}
        #pc-modal-backdrop[data-ec-welcome] .ec-welcome-eyebrow{display:block!important;font:600 9px/1.5 Arial,sans-serif!important;letter-spacing:1.5px!important;color:#a33b2c!important;margin-bottom:18px!important}
        #pc-modal-backdrop[data-ec-welcome] .form-block{display:flex!important;flex-direction:column!important;gap:12px!important;background:transparent!important;width:100%!important;max-width:none!important}
        #pc-modal-backdrop[data-ec-welcome] .pc-campaign-198486 #block-3:not(:has(.code-wrapper)){display:none!important}
        #pc-modal-backdrop[data-ec-welcome] .input-wrapper{width:100%!important;border:1px solid #d8d0c7!important;border-radius:0!important;background:#fff!important;min-height:50px!important;padding:0 14px!important;color:#242424!important}
        #pc-modal-backdrop[data-ec-welcome] .form-block-input{width:100%!important;background:#fff!important;color:#242424!important;font:14px Arial,sans-serif!important;height:48px!important;border:0!important;border-radius:0!important}
        #pc-modal-backdrop[data-ec-welcome] .submit-button{width:100%!important;min-height:51px!important;background:#242424!important;color:#fff!important;border:0!important;border-radius:0!important;font:500 13px Arial,sans-serif!important;transform:none!important}
        #pc-modal-backdrop[data-ec-welcome] .submit-button:hover{background:#a33b2c!important}
        #pc-modal-backdrop[data-ec-welcome] .ec-welcome-notes{margin-top:17px!important;color:#696158!important;font:11px/1.7 Arial,sans-serif!important;text-align:left!important}
        #pc-modal-backdrop[data-ec-welcome] .ec-welcome-notes p{margin:0 0 10px!important}
        #pc-modal-backdrop[data-ec-welcome] .ec-welcome-notes a{color:#8d3024!important;text-decoration:underline!important;text-underline-offset:3px!important}
        #pc-modal-backdrop[data-ec-welcome] #pc-modal-close-button{position:absolute!important;top:9px!important;right:9px!important;left:auto!important;bottom:auto!important;transform:none!important;z-index:2!important}
        #pc-modal-backdrop[data-ec-welcome] #pc-main-close-button{background:#faf8f5!important;color:#242424!important;border:0!important;border-radius:0!important;padding:7px!important;min-width:34px!important;min-height:34px!important}
        #pc-modal-backdrop[data-ec-welcome] input:focus-visible,#pc-modal-backdrop[data-ec-welcome] button:focus-visible,#pc-modal-backdrop[data-ec-welcome] a:focus-visible{outline:2px solid #a33b2c!important;outline-offset:3px!important}
        @media(max-width:480px){#pc-modal-backdrop[data-ec-welcome] .pop-content-blocks{padding:38px 25px 25px!important}#pc-modal-backdrop[data-ec-welcome] .text-block h1{font-size:32px!important}}
      `;
      root.append(style);
    }
    if (campaign) {
      const block = campaign.querySelector('#block-1 .text-block');
      const title = block?.querySelector('h1');
      const paragraph = Array.from(block?.querySelectorAll('p') || []).find(p => p.textContent.trim());
      setText(title, copy.title);
      setText(paragraph, copy.intro);
      if (block && !block.querySelector('.ec-welcome-eyebrow')) {
        const eyebrow = document.createElement('span');
        eyebrow.className = 'ec-welcome-eyebrow';
        eyebrow.textContent = copy.eyebrow;
        block.prepend(eyebrow);
      }
      const email = campaign.querySelector('.form-block-input');
      if (email) {
        email.type = 'email';
        email.autocomplete = 'email';
        email.inputMode = 'email';
        email.placeholder = copy.email;
        email.setAttribute('aria-label', copy.email);
      }
      const submit = campaign.querySelector('.form-block-submit-button');
      if (submit && !submit.querySelector('.spinner')) setText(submit, copy.button);
      if (!campaign.querySelector('.ec-welcome-notes')) {
        const notes = document.createElement('div');
        notes.className = 'ec-welcome-notes';
        for (const value of [copy.conditions, copy.consent]) {
          const p = document.createElement('p');
          p.textContent = value;
          notes.append(p);
        }
        const link = document.createElement('a');
        link.href = copy.privacy_url;
        link.textContent = copy.privacy;
        notes.append(link);
        campaign.append(notes);
      }
    }
    const close = modal.querySelector('#pc-main-close-button');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('aria-label', copy.close);
      close.tabIndex = 0;
      if (!close.dataset.ecKeyboard) {
        close.dataset.ecKeyboard = 'true';
        close.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); close.click(); }
        });
      }
    }
    if (code) {
      const title = modal.querySelector('h1');
      if (title) setText(title, copy.success);
      const closeButton = Array.from(modal.querySelectorAll('button')).find(button => /^(Fermer|Close|Cerrar)$/.test(button.textContent.trim()));
      setText(closeButton, copy.close);
    }
  };
  const connect = () => {
    const host = document.getElementById('pop-convert-app');
    const root = host?.shadowRoot;
    if (!root || root === observedRoot) return;
    observedRoot = root;
    rootObserver?.disconnect();
    rootObserver = new MutationObserver(() => {
      rootObserver.disconnect();
      decorate(root);
      rootObserver.observe(root, {childList: true, subtree: true, characterData: true});
    });
    decorate(root);
    rootObserver.observe(root, {childList: true, subtree: true, characterData: true});
  };
  connect();
  const hostObserver = new MutationObserver(connect);
  hostObserver.observe(document.body, {childList: true, subtree: true});
  const discovery = setInterval(connect, 1000);
  setTimeout(() => clearInterval(discovery), 30000);
})();
